webpackJsonp([1],{

/***/ 142:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = {
	name: 'app',
	components: {}
};

/***/ }),

/***/ 143:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    props: {
        dialogTableVisible: {
            type: Boolean,
            default: false
        }
    },
    data: function data() {
        return {
            gridData: [{
                invoiceNumber: 'INV0001',
                accountCode: '100',
                amount: '250',
                reference: 'Payment Reference 1',
                paymentDate: '01/30/2019'
            }, {
                invoiceNumber: 'INV0001',
                accountCode: '100',
                amount: '250',
                reference: 'Payment Reference 2',
                paymentDate: '01/30/2019'
            }, {
                invoiceNumber: 'INV0002',
                accountCode: '2100',
                amount: '1500',
                reference: 'Payment Reference 3',
                paymentDate: '01/30/2019'
            }, {
                invoiceNumber: 'INV0002',
                accountCode: '2100',
                amount: '1000',
                reference: 'Payment Reference 4',
                paymentDate: '01/30/2019'
            }],
            dialogFormVisible: false
        };
    }
};

/***/ }),

/***/ 144:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    props: {
        dialogTableVisible: {
            type: Boolean,
            default: false
        }
    },
    data: function data() {
        return {
            gridData: [{
                reference: 'Reference 1',
                invoiceDate: '01/30/2019',
                customerName: 'John Smith',
                amount: '500',
                currencyCode: 'USD',
                introduction: 'Introduction 1',
                productNumber: 'PR001',
                quantity: '1',
                price: '100',
                accountCode: '4000',
                taxType: 'TAX INCLUSIVE',
                tax: 'VAT 12%',
                invoiceDueDate: '02/30/2019',
                invoiceNumber: 'INV001'
            }, {
                reference: 'Reference 1',
                invoiceDate: '01/30/2019',
                customerName: 'John Smith',
                amount: '500',
                currencyCode: 'USD',
                introduction: 'Introduction 1',
                productNumber: 'PR002',
                quantity: '2',
                price: '200',
                accountCode: '4000',
                taxType: 'TAX INCLUSIVE',
                tax: 'VAT 12%',
                invoiceDueDate: '02/30/2019',
                invoiceNumber: 'INV001'
            }, {
                reference: 'Reference 2',
                invoiceDate: '01/30/2019',
                customerName: 'John Adam',
                amount: '2500',
                currencyCode: 'USD',
                introduction: 'Introduction 3',
                productNumber: 'PR003',
                quantity: '3',
                price: '300',
                accountCode: '4000',
                taxType: 'TAX INCLUSIVE',
                tax: 'VAT 12%',
                invoiceDueDate: '02/30/2019',
                invoiceNumber: 'INV001'
            }, {
                reference: 'Reference 2',
                invoiceDate: '01/30/2019',
                customerName: 'John Adam',
                amount: '2500',
                currencyCode: 'USD',
                introduction: 'Introduction 4',
                productNumber: 'PR004',
                quantity: '4',
                price: '400',
                accountCode: '4000',
                taxType: 'TAX INCLUSIVE',
                tax: 'VAT 12%',
                invoiceDueDate: '02/30/2019',
                invoiceNumber: 'INV001'
            }],
            dialogFormVisible: false
        };
    }
};

/***/ }),

/***/ 145:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    props: {
        dialogTableVisible: {
            type: Boolean,
            default: false
        }
    },
    data: function data() {
        return {
            gridData: [{
                number: 'SO0001',
                customerName: 'John Smith',
                date: '01/01/2019',
                validDate: '01/30/2019',
                reference: 'reference test',
                currency: 'USD',
                exchangeRate: '1',
                taxType: 'Tax Exclusive',
                item: 'PD0001',
                description: 'Test description',
                quantity: '1',
                unitMeasurement: 'Each',
                price: '100',
                discountType: 'Fixed Amount',
                discountAmount: '50',
                salesAccount: '4000',
                tax: 'VAT(0.05%)',
                department: 'Sales Department'
            }, {
                number: 'SO0002',
                customerName: 'Adam Smith',
                date: '01/02/2019',
                validDate: '01/30/2019',
                reference: 'reference test',
                currency: 'USD',
                exchangeRate: '1',
                taxType: 'Tax Inclusive',
                item: 'PD0002',
                description: 'Test description',
                quantity: '1',
                unitMeasurement: 'Each',
                price: '100',
                discountType: 'Fixed Amount',
                discountAmount: '50',
                salesAccount: '4000',
                tax: 'VAT(0.00%)',
                department: 'IT Department'
            }, {
                number: 'SO0003',
                customerName: 'John Smith',
                date: '01/03/2019',
                validDate: '01/30/2019',
                reference: 'reference test',
                currency: 'USD',
                exchangeRate: '1',
                taxType: 'Tax Exclusive',
                item: 'PD0003',
                description: 'Test description',
                quantity: '1',
                unitMeasurement: 'Each',
                price: '100',
                discountType: 'Fixed Amount',
                discountAmount: '50',
                salesAccount: '4000',
                tax: 'VAT(0.00%)',
                department: 'Sales Department'
            }, {
                number: 'SO0004',
                customerName: 'John Smith',
                date: '01/03/2019',
                validDate: '01/30/2019',
                reference: 'reference test',
                currency: 'SAR',
                exchangeRate: '0.075',
                taxType: 'Tax Inclusive',
                item: 'PD0004',
                description: 'Test description',
                quantity: '1',
                unitMeasurement: 'Each',
                price: '100',
                discountType: 'Percentage',
                discountAmount: '5',
                salesAccount: '4000',
                tax: 'VAT(0.00%)',
                department: 'Admin Department'
            }],
            dialogFormVisible: false
        };
    }
};

/***/ }),

/***/ 146:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = {
	data: function data() {
		return {
			sysName: 'Import',
			collapsed: false,
			sysUserName: 'System Admin',
			sysUserAvatar: '',
			form: {
				name: '',
				region: '',
				date1: '',
				date2: '',
				delivery: false,
				type: [],
				resource: '',
				desc: ''
			},
			companyID: sessionStorage.getItem('company_name')
		};
	},

	methods: {
		onSubmit: function onSubmit() {
			console.log('submit!');
		},
		handleopen: function handleopen() {},
		handleclose: function handleclose() {},

		handleselect: function handleselect(a, b) {},
		logout: function logout() {
			var _this = this;
			this.$confirm('Are you sure you want to log out?', 'Confirm', {}).then(function () {
				sessionStorage.removeItem('token');
				sessionStorage.removeItem('company_name');
				_this.$router.push('/login');
			}).catch(function () {});
		},
		collapse: function collapse() {
			this.collapsed = !this.collapsed;
		},
		showMenu: function showMenu(i, status) {
			this.$refs.menuCollapsed.getElementsByClassName('submenu-hook-' + i)[0].style.display = status ? 'block' : 'none';
		}
	},
	mounted: function mounted() {
		var user = sessionStorage.getItem('user');

		if (user) {
			user = JSON.parse(user);
			this.sysUserName = user.name || '';
			this.sysUserAvatar = user.avatar || '';
		}
	}
};

/***/ }),

/***/ 147:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _api = __webpack_require__(19);

exports.default = {
    data: function data() {
        return {
            logining: false,
            ruleForm2: {
                account: '',
                checkPass: ''
            },
            rules2: {
                account: [{ required: true, message: 'Login is required.', trigger: 'blur' }],
                checkPass: [{ required: true, message: 'Password is required', trigger: 'blur' }]
            },
            checked: true,
            companies_list: null
        };
    },

    methods: {
        onLogin: function onLogin() {
            var _this = this;

            this.$refs.ruleForm2.validate(function (valid) {

                if (valid) {
                    _this.logining = true;
                    var loginParams = { email: _this.ruleForm2.account, password: _this.ruleForm2.checkPass };
                    (0, _api.requestToLogin)(loginParams).then(function (data) {
                        var token = data.data.token;


                        if (!token) {
                            _this.$message({
                                message: msg,
                                type: 'error'
                            });
                        } else {
                            sessionStorage.setItem('token', token);
                            (0, _api.getCompaniesList)().then(function (data) {
                                _this.companies_list = data.data.companies;
                            }).catch(function (error) {
                                _this.logining = false;
                                console.log(error);
                                console.log(error.response);
                            });
                        }
                    }).catch(function (error) {
                        _this.logining = false;
                        console.log(error);
                        console.log(error.response);
                    });
                } else {
                    console.log('error submit!!');
                    return false;
                }
            });
        },
        loginByCompany: function loginByCompany(company_name, company_id) {
            var _this2 = this;

            (0, _api.loginByCompany)(company_id).then(function (data) {
                sessionStorage.setItem('company_name', company_name);
                sessionStorage.setItem('token', data.data.token);
                _this2.$router.push({ path: '/invoice-import' });
            }).catch(function (error) {
                _this2.logining = false;
                console.log(error);
                console.log(error.response);
            });
        }
    }
};

/***/ }),

/***/ 148:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getIterator2 = __webpack_require__(35);

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _util = __webpack_require__(34);

var _util2 = _interopRequireDefault(_util);

var _InvoicePopup = __webpack_require__(229);

var _InvoicePopup2 = _interopRequireDefault(_InvoicePopup);

var _api = __webpack_require__(19);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    components: {
        InvoicePopup: _InvoicePopup2.default
    },
    data: function data() {
        return {
            importLogs: [],
            total: 0,
            page: 1,
            size: 20,
            listLoading: false,
            fromDate: new Date(),
            toDate: new Date(),
            entityType: 'INVOICE',
            sortingColumn: {
                prop: 'import_date',
                order: 'descending'
            },
            dialogTableVisible: false
        };
    },

    methods: {
        handleCurrentChange: function handleCurrentChange(val) {
            this.page = val;
            this.getLogs();
        },
        handlePageSizeChange: function handlePageSizeChange(val) {
            this.size = val;
            this.getLogs();
        },
        handleSorting: function handleSorting(obj) {
            console.log(obj);

            if (obj && obj.column) {
                this.sortingColumn.prop = obj.prop;
                this.sortingColumn.order = obj.order;
                this.getLogs();
            }
        },
        getLogs: function getLogs() {
            var _this = this;

            this.listLoading = true;
            var params = {
                page: this.page,
                size: this.size,
                fromDate: _util2.default.formatDate.format(new Date(this.fromDate), 'yyyy-MM-dd'),
                toDate: _util2.default.formatDate.format(new Date(this.toDate), 'yyyy-MM-dd'),
                column: this.sortingColumn.prop,
                sortType: this.sortingColumn.order,
                entityType: 'INVOICE'
            };
            (0, _api.getImportLogs)(params).then(function (res) {
                var data = res.data.data;
                _this.total = data.totalElements;
                _this.importLogs = data.items;
                _this.listLoading = false;
            });
        },
        reloadImportLogs: function reloadImportLogs() {
            this.getLogs();
        },
        submitFile: function submitFile(res) {
            var _this2 = this;

            var formData = new FormData();
            formData.append('uploadFile', res.file);
            formData.append('entityType', 'INVOICE');

            (0, _api.uploadFile)(formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            }).then(function (res) {
                _this2.listLoading = false;
                _this2.getLogs();
            }).catch(function (error) {
                _this2.listLoading = false;
                _this2.getLogs();
            });
        },
        beforeUpload: function beforeUpload() {
            this.listLoading = true;
        },
        submitUpload: function submitUpload() {
            this.$refs.upload.submit();
        },
        closeModal: function closeModal() {
            this.dialogTableVisible = false;
        }
    },
    computed: {
        importLogItems: function importLogItems() {
            var items = [];

            if (this.importLogs) {
                var _iteratorNormalCompletion = true;
                var _didIteratorError = false;
                var _iteratorError = undefined;

                try {
                    for (var _iterator = (0, _getIterator3.default)(this.importLogs), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                        var importLog = _step.value;

                        importLog.import_date = _util2.default.formatDate.format(new Date(importLog.import_date), 'yyyy-MM-dd hh:mm');
                        items.push(importLog);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return) {
                            _iterator.return();
                        }
                    } finally {
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }

            return items;
        }
    },
    mounted: function mounted() {
        this.getLogs();
    }
};

/***/ }),

/***/ 149:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getIterator2 = __webpack_require__(35);

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _util = __webpack_require__(34);

var _util2 = _interopRequireDefault(_util);

var _api = __webpack_require__(19);

var _InvoicePaymentPopup = __webpack_require__(228);

var _InvoicePaymentPopup2 = _interopRequireDefault(_InvoicePaymentPopup);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    components: {
        InvoicePaymentPopup: _InvoicePaymentPopup2.default
    },
    data: function data() {
        return {
            importLogs: [],
            total: 0,
            page: 1,
            size: 20,
            listLoading: false,
            fromDate: new Date(),
            toDate: new Date(),
            entityType: 'INVOICE_PAYMENT',
            sortingColumn: {
                prop: 'import_date',
                order: 'descending'
            },
            dialogTableVisible: false
        };
    },

    methods: {
        handleCurrentChange: function handleCurrentChange(val) {
            this.page = val;
            this.getLogs();
        },
        handlePageSizeChange: function handlePageSizeChange(val) {
            this.size = val;
            this.getLogs();
        },
        handleSorting: function handleSorting(obj) {
            console.log(obj);

            if (obj && obj.column) {
                this.sortingColumn.prop = obj.prop;
                this.sortingColumn.order = obj.order;
                this.getLogs();
            }
        },
        getLogs: function getLogs() {
            var _this = this;

            this.listLoading = true;
            var params = {
                page: this.page,
                size: this.size,
                fromDate: _util2.default.formatDate.format(new Date(this.fromDate), 'yyyy-MM-dd'),
                toDate: _util2.default.formatDate.format(new Date(this.toDate), 'yyyy-MM-dd'),
                column: this.sortingColumn.prop,
                sortType: this.sortingColumn.order,
                entityType: 'INVOICE_PAYMENT'
            };
            (0, _api.getImportLogs)(params).then(function (res) {
                var data = res.data.data;
                _this.total = data.totalElements;
                _this.importLogs = data.items;
                _this.listLoading = false;
            });
        },
        reloadImportLogs: function reloadImportLogs() {
            this.getLogs();
        },
        submitFile: function submitFile(res) {
            var _this2 = this;

            var formData = new FormData();
            formData.append('uploadFile', res.file);
            formData.append('entityType', 'INVOICE_PAYMENT');

            (0, _api.uploadFile)(formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            }).then(function (res) {
                _this2.listLoading = false;
                _this2.getLogs();
            }).catch(function (error) {
                _this2.listLoading = false;
                _this2.getLogs();
            });
        },
        beforeUpload: function beforeUpload() {
            this.listLoading = true;
        },
        submitUpload: function submitUpload() {
            this.$refs.upload.submit();
        },
        closeModal: function closeModal() {
            this.dialogTableVisible = false;
        }
    },
    computed: {
        importLogItems: function importLogItems() {
            var items = [];

            if (this.importLogs) {
                var _iteratorNormalCompletion = true;
                var _didIteratorError = false;
                var _iteratorError = undefined;

                try {
                    for (var _iterator = (0, _getIterator3.default)(this.importLogs), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                        var importLog = _step.value;

                        importLog.import_date = _util2.default.formatDate.format(new Date(importLog.import_date), 'yyyy-MM-dd hh:mm');
                        items.push(importLog);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return) {
                            _iterator.return();
                        }
                    } finally {
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }

            return items;
        }
    },
    mounted: function mounted() {
        this.getLogs();
    }
};

/***/ }),

/***/ 150:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getIterator2 = __webpack_require__(35);

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _util = __webpack_require__(34);

var _util2 = _interopRequireDefault(_util);

var _SalesOrderPopup = __webpack_require__(230);

var _SalesOrderPopup2 = _interopRequireDefault(_SalesOrderPopup);

var _api = __webpack_require__(19);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    components: {
        SalesOrderPopup: _SalesOrderPopup2.default
    },
    data: function data() {
        return {
            importLogs: [],
            total: 0,
            page: 1,
            size: 20,
            listLoading: false,
            fromDate: new Date(),
            toDate: new Date(),
            entityType: 'SALES_ORDER',
            sortingColumn: {
                prop: 'import_date',
                order: 'descending'
            },
            dialogTableVisible: false
        };
    },

    methods: {
        handleCurrentChange: function handleCurrentChange(val) {
            this.page = val;
            this.getLogs();
        },
        handlePageSizeChange: function handlePageSizeChange(val) {
            this.size = val;
            this.getLogs();
        },
        handleSorting: function handleSorting(obj) {
            console.log(obj);

            if (obj && obj.column) {
                this.sortingColumn.prop = obj.prop;
                this.sortingColumn.order = obj.order;
                this.getLogs();
            }
        },
        getLogs: function getLogs() {
            var _this = this;

            this.listLoading = true;
            var params = {
                page: this.page,
                size: this.size,
                fromDate: _util2.default.formatDate.format(new Date(this.fromDate), 'yyyy-MM-dd'),
                toDate: _util2.default.formatDate.format(new Date(this.toDate), 'yyyy-MM-dd'),
                column: this.sortingColumn.prop,
                sortType: this.sortingColumn.order,
                entityType: 'SALES_ORDER'
            };
            (0, _api.getImportLogs)(params).then(function (res) {
                var data = res.data.data;
                _this.total = data.totalElements;
                _this.importLogs = data.items;
                _this.listLoading = false;
            });
        },
        reloadImportLogs: function reloadImportLogs() {
            this.getLogs();
        },
        submitFile: function submitFile(res) {
            var _this2 = this;

            var formData = new FormData();
            formData.append('uploadFile', res.file);
            formData.append('entityType', 'SALES_ORDER');

            (0, _api.uploadFile)(formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            }).then(function (res) {
                _this2.listLoading = false;
                _this2.getLogs();
            }).catch(function (error) {
                _this2.listLoading = false;
                _this2.getLogs();
            });
        },
        beforeUpload: function beforeUpload() {
            this.listLoading = true;
        },
        submitUpload: function submitUpload() {
            this.$refs.upload.submit();
        },
        closeModal: function closeModal() {
            this.dialogTableVisible = false;
        }
    },
    computed: {
        importLogItems: function importLogItems() {
            var items = [];

            if (this.importLogs) {
                var _iteratorNormalCompletion = true;
                var _didIteratorError = false;
                var _iteratorError = undefined;

                try {
                    for (var _iterator = (0, _getIterator3.default)(this.importLogs), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                        var importLog = _step.value;

                        importLog.import_date = _util2.default.formatDate.format(new Date(importLog.import_date), 'yyyy-MM-dd hh:mm');
                        items.push(importLog);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return) {
                            _iterator.return();
                        }
                    } finally {
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }

            return items;
        }
    },
    mounted: function mounted() {
        this.getLogs();
    }
};

/***/ }),

/***/ 151:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _vue = __webpack_require__(4);

var _vue2 = _interopRequireDefault(_vue);

var _App = __webpack_require__(99);

var _App2 = _interopRequireDefault(_App);

var _elementUi = __webpack_require__(95);

var _elementUi2 = _interopRequireDefault(_elementUi);

var _en = __webpack_require__(96);

var _en2 = _interopRequireDefault(_en);

__webpack_require__(97);

var _vueRouter = __webpack_require__(100);

var _vueRouter2 = _interopRequireDefault(_vueRouter);

var _store = __webpack_require__(94);

var _store2 = _interopRequireDefault(_store);

var _vuex = __webpack_require__(58);

var _vuex2 = _interopRequireDefault(_vuex);

var _routes = __webpack_require__(93);

var _routes2 = _interopRequireDefault(_routes);

var _vueCookies = __webpack_require__(98);

var _vueCookies2 = _interopRequireDefault(_vueCookies);

var _api = __webpack_require__(19);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.use(_elementUi2.default, { locale: _en2.default });
_vue2.default.use(_vueRouter2.default);
_vue2.default.use(_vuex2.default);
_vue2.default.use(_vueCookies2.default);

var router = new _vueRouter2.default({
    routes: _routes2.default
});

router.beforeEach(function (to, from, next) {

    if (to.path != '/login') {
        var token = sessionStorage.getItem('token');

        if (!token) {
            next({ path: '/login' });
        } else {
            _api.HTTP.defaults.headers.common.Authentication = token;
            next();
        }
    } else {
        next();
    }
});

new _vue2.default({
    router: router,
    store: _store2.default,
    render: function render(h) {
        return h(_App2.default);
    }
}).$mount('#app');

/***/ }),

/***/ 19:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getImportLogs = exports.uploadFile = exports.loginByCompany = exports.getCompaniesList = exports.requestToLogin = exports.HTTP = undefined;

var _promise = __webpack_require__(153);

var _promise2 = _interopRequireDefault(_promise);

var _axios = __webpack_require__(123);

var _axios2 = _interopRequireDefault(_axios);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var HTTP = exports.HTTP = _axios2.default.create({
    baseURL:  true ? '/api/v1' : 'https://api-import.kpi.com/api/v1'
});

HTTP.interceptors.response.use(function (response) {
    console.log("ENV:" + "production");
    if (response) {
        console.log(response);
    }
    return response;
}, function (error) {
    return _promise2.default.reject(error);
});

var requestToLogin = exports.requestToLogin = function requestToLogin(params) {
    return HTTP.post('/auth/login', params).then(function (res) {
        return res.data;
    });
};

var getCompaniesList = exports.getCompaniesList = function getCompaniesList() {
    setAuthToken();
    return HTTP.get('/auth/getCompaniesList').then(function (res) {
        return res.data;
    });
};

var loginByCompany = exports.loginByCompany = function loginByCompany(params) {
    setAuthToken();
    return HTTP.get('/auth/loginByCompany/' + params).then(function (res) {
        return res.data;
    });
};

var uploadFile = exports.uploadFile = function uploadFile(param, conf) {
    setAuthToken();
    return HTTP.post('/upload_file', param, conf);
};

var getImportLogs = exports.getImportLogs = function getImportLogs(params) {
    setAuthToken();
    return HTTP.get('/import_logs', { params: params });
};

var setAuthToken = function setAuthToken() {
    if (sessionStorage.getItem('token')) {
        HTTP.defaults.headers.common['Authentication'] = sessionStorage.getItem('token');
        console.log("SessionID: " + sessionStorage.getItem('token'));
    }
};

/***/ }),

/***/ 213:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 214:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 215:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 216:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 217:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 218:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 219:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 228:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(7)(
  /* script */
  __webpack_require__(143),
  /* template */
  __webpack_require__(246),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 229:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(7)(
  /* script */
  __webpack_require__(144),
  /* template */
  __webpack_require__(244),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 230:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(7)(
  /* script */
  __webpack_require__(145),
  /* template */
  __webpack_require__(239),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 231:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(213)

var Component = __webpack_require__(7)(
  /* script */
  null,
  /* template */
  __webpack_require__(237),
  /* scopeId */
  "data-v-2d4f8f4a",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 232:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(218)

var Component = __webpack_require__(7)(
  /* script */
  __webpack_require__(146),
  /* template */
  __webpack_require__(243),
  /* scopeId */
  "data-v-6fcd0628",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 233:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(216)

var Component = __webpack_require__(7)(
  /* script */
  __webpack_require__(147),
  /* template */
  __webpack_require__(241),
  /* scopeId */
  "data-v-58fb072c",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 234:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(215)

var Component = __webpack_require__(7)(
  /* script */
  __webpack_require__(148),
  /* template */
  __webpack_require__(240),
  /* scopeId */
  "data-v-45903813",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 235:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(217)

var Component = __webpack_require__(7)(
  /* script */
  __webpack_require__(149),
  /* template */
  __webpack_require__(242),
  /* scopeId */
  "data-v-5eeeb14d",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 236:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(214)

var Component = __webpack_require__(7)(
  /* script */
  __webpack_require__(150),
  /* template */
  __webpack_require__(238),
  /* scopeId */
  "data-v-3244edd4",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 237:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "page-container"
  }, [_vm._v("404 page not found")])
},staticRenderFns: []}

/***/ }),

/***/ 238:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('el-row', {
    attrs: {
      "gutter": 24
    }
  }, [_c('el-col', {
    attrs: {
      "span": 10
    }
  }, [_c('div', {
    staticStyle: {
      "float": "left",
      "margin-right": "1px",
      "margin-top": "5px"
    }
  }, [_vm._v("Range:")]), _vm._v(" "), _c('el-date-picker', {
    staticStyle: {
      "width": "150px"
    },
    attrs: {
      "type": "date",
      "size": "small",
      "placeholder": "From date"
    },
    model: {
      value: (_vm.fromDate),
      callback: function($$v) {
        _vm.fromDate = $$v
      },
      expression: "fromDate"
    }
  }), _vm._v("\n            -\n            "), _c('el-date-picker', {
    staticStyle: {
      "width": "150px"
    },
    attrs: {
      "type": "date",
      "size": "small",
      "placeholder": "To date"
    },
    model: {
      value: (_vm.toDate),
      callback: function($$v) {
        _vm.toDate = $$v
      },
      expression: "toDate"
    }
  }), _vm._v(" "), _c('el-button', {
    attrs: {
      "size": "small",
      "type": "success"
    },
    on: {
      "click": _vm.reloadImportLogs
    }
  }, [_vm._v("Update")])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 4,
      "lg": 6,
      "push": 1
    }
  }, [_c('el-upload', {
    ref: "upload",
    staticStyle: {
      "float": "left"
    },
    attrs: {
      "action": "",
      "http-request": _vm.submitFile,
      "before-upload": _vm.beforeUpload,
      "auto-upload": false
    }
  }, [_c('el-button', {
    attrs: {
      "slot": "trigger",
      "size": "small",
      "type": "primary",
      "title": "Upload csv files only!"
    },
    slot: "trigger"
  }, [_vm._v("Select File\n                ")]), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "margin-left": "10px"
    },
    attrs: {
      "size": "small",
      "type": "success"
    },
    on: {
      "click": _vm.submitUpload
    }
  }, [_vm._v("Upload To\n                    Server\n                ")])], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 4,
      "lg": 6,
      "push": 1
    }
  }, [_c('el-button', {
    attrs: {
      "type": "text"
    },
    on: {
      "click": function($event) {
        _vm.dialogTableVisible = true
      }
    }
  }, [_vm._v("How to import sales orders?")]), _vm._v(" "), _c('SalesOrderPopup', {
    attrs: {
      "dialogTableVisible": _vm.dialogTableVisible
    },
    on: {
      "onClose": _vm.closeModal
    }
  })], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.listLoading),
      expression: "listLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.importLogItems,
      "highlight-current-row": "",
      "default-sort": _vm.sortingColumn
    },
    on: {
      "sort-change": _vm.handleSorting
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "import_date",
      "label": "Date",
      "sortable": "custom"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "status",
      "label": "Status",
      "sortable": "custom"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "requested",
      "label": "Requested"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "imported",
      "label": "Imported"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "rejected",
      "label": "Rejected"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "imported_file",
      "label": "Imported File"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('a', {
          attrs: {
            "href": scope.row.imported_file_url,
            "size": "small"
          }
        }, [_vm._v(_vm._s(scope.row.imported_file))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "log_file",
      "label": "Log File"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('a', {
          attrs: {
            "href": scope.row.log_file_url,
            "size": "small"
          }
        }, [_vm._v(_vm._s(scope.row.log_file))])]
      }
    }])
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "layout": "sizes, total, prev, pager, next",
      "page-size": 20,
      "total": _vm.total
    },
    on: {
      "current-change": _vm.handleCurrentChange,
      "size-change": _vm.handlePageSizeChange
    }
  })], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 239:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-col', {
    attrs: {
      "span": 4,
      "lg": 6,
      "push": 1
    }
  }, [_c('el-dialog', {
    attrs: {
      "width": "1000",
      "title": "Sales Order Sample Data",
      "visible": _vm.dialogTableVisible
    },
    on: {
      "close": function($event) {
        _vm.$emit('onClose')
      }
    }
  }, [_c('el-table', {
    attrs: {
      "data": _vm.gridData
    }
  }, [_c('el-table-column', {
    attrs: {
      "property": "number",
      "label": "Number",
      "width": "80"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "property": "customerName",
      "label": "Customer Name",
      "width": "100"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "property": "date",
      "label": "Date",
      "width": "80"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "property": "validDate",
      "label": "Valid Date",
      "width": "80"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "property": "reference",
      "label": "Reference",
      "width": "80"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "property": "currency",
      "label": "Currency",
      "width": "80"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "property": "exchangeRate",
      "label": "Exchange Rate",
      "width": "80"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "property": "taxType",
      "label": "Tax Type",
      "width": "80"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "property": "item",
      "label": "Item",
      "width": "80"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "property": "description",
      "label": "Description",
      "width": "80"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "property": "quantity",
      "label": "Qty",
      "width": "80"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "property": "unitMeasurement",
      "label": "U/M",
      "width": "80"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "property": "price",
      "label": "Price",
      "width": "80"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "property": "discountType",
      "label": "Discount Type",
      "width": "80"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "property": "discountAmount",
      "label": "Discount Amount",
      "width": "80"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "property": "salesAccount",
      "label": "Sales Account",
      "width": "80"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "property": "tax",
      "label": "Tax",
      "width": "80"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "property": "department",
      "label": "Department",
      "width": "80"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('p', [_vm._v("Sales Order date format should be "), _c('b', [_vm._v("MM/dd/yyyy")]), _vm._v(" format. You can download sample file "), _c('a', {
    attrs: {
      "href": "https://s3.amazonaws.com/workforcetrack/000000000000/invoice-import-app/public/Sales_Order_Import_Template.csv"
    }
  }, [_vm._v("here")])])])], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 240:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('el-row', {
    attrs: {
      "gutter": 24
    }
  }, [_c('el-col', {
    attrs: {
      "span": 10
    }
  }, [_c('div', {
    staticStyle: {
      "float": "left",
      "margin-right": "1px",
      "margin-top": "5px"
    }
  }, [_vm._v("Range:")]), _vm._v(" "), _c('el-date-picker', {
    staticStyle: {
      "width": "150px"
    },
    attrs: {
      "type": "date",
      "size": "small",
      "placeholder": "From date"
    },
    model: {
      value: (_vm.fromDate),
      callback: function($$v) {
        _vm.fromDate = $$v
      },
      expression: "fromDate"
    }
  }), _vm._v("\n            -\n            "), _c('el-date-picker', {
    staticStyle: {
      "width": "150px"
    },
    attrs: {
      "type": "date",
      "size": "small",
      "placeholder": "To date"
    },
    model: {
      value: (_vm.toDate),
      callback: function($$v) {
        _vm.toDate = $$v
      },
      expression: "toDate"
    }
  }), _vm._v(" "), _c('el-button', {
    attrs: {
      "size": "small",
      "type": "success"
    },
    on: {
      "click": _vm.reloadImportLogs
    }
  }, [_vm._v("Update")])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 4,
      "lg": 6,
      "push": 1
    }
  }, [_c('el-upload', {
    ref: "upload",
    staticStyle: {
      "float": "left"
    },
    attrs: {
      "action": "",
      "http-request": _vm.submitFile,
      "before-upload": _vm.beforeUpload,
      "auto-upload": false
    }
  }, [_c('el-button', {
    attrs: {
      "slot": "trigger",
      "size": "small",
      "type": "primary",
      "title": "Upload csv files only!"
    },
    slot: "trigger"
  }, [_vm._v("Select File\n                ")]), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "margin-left": "10px"
    },
    attrs: {
      "size": "small",
      "type": "success"
    },
    on: {
      "click": _vm.submitUpload
    }
  }, [_vm._v("Upload To\n                    Server\n                ")])], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 4,
      "lg": 6,
      "push": 1
    }
  }, [_c('el-button', {
    attrs: {
      "type": "text"
    },
    on: {
      "click": function($event) {
        _vm.dialogTableVisible = true
      }
    }
  }, [_vm._v("How to import invoices?")]), _vm._v(" "), _c('InvoicePopup', {
    attrs: {
      "dialogTableVisible": _vm.dialogTableVisible
    },
    on: {
      "onClose": _vm.closeModal
    }
  })], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.listLoading),
      expression: "listLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.importLogItems,
      "highlight-current-row": "",
      "default-sort": _vm.sortingColumn
    },
    on: {
      "sort-change": _vm.handleSorting
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "import_date",
      "label": "Date",
      "sortable": "custom"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "status",
      "label": "Status",
      "sortable": "custom"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "requested",
      "label": "Requested"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "imported",
      "label": "Imported"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "rejected",
      "label": "Rejected"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "imported_file",
      "label": "Imported File"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('a', {
          attrs: {
            "href": scope.row.imported_file_url,
            "size": "small"
          }
        }, [_vm._v(_vm._s(scope.row.imported_file))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "log_file",
      "label": "Log File"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('a', {
          attrs: {
            "href": scope.row.log_file_url,
            "size": "small"
          }
        }, [_vm._v(_vm._s(scope.row.log_file))])]
      }
    }])
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "layout": "sizes, total, prev, pager, next",
      "page-size": 20,
      "total": _vm.total
    },
    on: {
      "current-change": _vm.handleCurrentChange,
      "size-change": _vm.handlePageSizeChange
    }
  })], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 241:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.companies_list) ? _c('el-form', {
    staticClass: "demo-ruleForm login-container",
    attrs: {
      "label-position": "left",
      "label-width": "0px"
    }
  }, [_c('el-form-item', {
    staticStyle: {
      "width": "100%"
    }
  }, _vm._l((_vm.companies_list), function(company) {
    return _c('el-button', {
      key: company.company_id,
      staticClass: "login__company",
      staticStyle: {
        "width": "100%",
        "margin": "5px"
      },
      attrs: {
        "type": "button",
        "role": "button"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.loginByCompany(company.company_name, company.company_id)
        }
      }
    }, [_c('span', [_c('b', [_vm._v(_vm._s(company.company_name))]), _c('br'), _c('br'), _vm._v(" ID:" + _vm._s(company.company_id) + " ")])])
  }))], 1) : _c('el-form', {
    ref: "ruleForm2",
    staticClass: "demo-ruleForm login-container",
    attrs: {
      "model": _vm.ruleForm2,
      "rules": _vm.rules2,
      "label-position": "left",
      "label-width": "0px"
    }
  }, [_c('h3', {
    staticClass: "title"
  }, [_vm._v("Sign In")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "account"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "auto-complete": "off",
      "placeholder": "login"
    },
    model: {
      value: (_vm.ruleForm2.account),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm2, "account", $$v)
      },
      expression: "ruleForm2.account"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "checkPass"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "password",
      "auto-complete": "off",
      "placeholder": "password"
    },
    model: {
      value: (_vm.ruleForm2.checkPass),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm2, "checkPass", $$v)
      },
      expression: "ruleForm2.checkPass"
    }
  })], 1), _vm._v(" "), _c('el-checkbox', {
    staticClass: "remember",
    attrs: {
      "checked": ""
    },
    model: {
      value: (_vm.checked),
      callback: function($$v) {
        _vm.checked = $$v
      },
      expression: "checked"
    }
  }, [_vm._v("Remember")]), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "width": "100%"
    }
  }, [_c('el-button', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "primary",
      "loading": _vm.logining
    },
    nativeOn: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.onLogin($event)
      }
    }
  }, [_vm._v("\n            Login\n        ")])], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 242:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('el-row', {
    attrs: {
      "gutter": 24
    }
  }, [_c('el-col', {
    attrs: {
      "span": 10
    }
  }, [_c('div', {
    staticStyle: {
      "float": "left",
      "margin-right": "1px",
      "margin-top": "5px"
    }
  }, [_vm._v("Range:")]), _vm._v(" "), _c('el-date-picker', {
    staticStyle: {
      "width": "150px"
    },
    attrs: {
      "type": "date",
      "size": "small",
      "placeholder": "From date"
    },
    model: {
      value: (_vm.fromDate),
      callback: function($$v) {
        _vm.fromDate = $$v
      },
      expression: "fromDate"
    }
  }), _vm._v("\n            -\n            "), _c('el-date-picker', {
    staticStyle: {
      "width": "150px"
    },
    attrs: {
      "type": "date",
      "size": "small",
      "placeholder": "To date"
    },
    model: {
      value: (_vm.toDate),
      callback: function($$v) {
        _vm.toDate = $$v
      },
      expression: "toDate"
    }
  }), _vm._v(" "), _c('el-button', {
    attrs: {
      "size": "small",
      "type": "success"
    },
    on: {
      "click": _vm.reloadImportLogs
    }
  }, [_vm._v("Update")])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 4,
      "lg": 6,
      "push": 1
    }
  }, [_c('el-upload', {
    ref: "upload",
    staticStyle: {
      "float": "left"
    },
    attrs: {
      "action": "",
      "http-request": _vm.submitFile,
      "before-upload": _vm.beforeUpload,
      "auto-upload": false
    }
  }, [_c('el-button', {
    attrs: {
      "slot": "trigger",
      "size": "small",
      "type": "primary"
    },
    slot: "trigger"
  }, [_vm._v("Select File")]), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "margin-left": "10px"
    },
    attrs: {
      "size": "small",
      "type": "success"
    },
    on: {
      "click": _vm.submitUpload
    }
  }, [_vm._v("Upload To\n                    Server\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "el-upload__tip",
    attrs: {
      "slot": "tip"
    },
    slot: "tip"
  }, [_vm._v("Upload csv files only!")])], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 4,
      "lg": 6,
      "push": 1
    }
  }, [_c('el-button', {
    attrs: {
      "type": "text"
    },
    on: {
      "click": function($event) {
        _vm.dialogTableVisible = true
      }
    }
  }, [_vm._v("How to import invoice payments?")]), _vm._v(" "), _c('InvoicePaymentPopup', {
    attrs: {
      "dialogTableVisible": _vm.dialogTableVisible
    },
    on: {
      "onClose": _vm.closeModal
    }
  })], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.listLoading),
      expression: "listLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.importLogItems,
      "highlight-current-row": "",
      "default-sort": _vm.sortingColumn
    },
    on: {
      "sort-change": _vm.handleSorting
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "import_date",
      "label": "Date",
      "sortable": "custom"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "status",
      "label": "Status",
      "sortable": "custom"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "requested",
      "label": "Requested"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "imported",
      "label": "Imported"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "rejected",
      "label": "Rejected"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "imported_file",
      "label": "Imported File"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('a', {
          attrs: {
            "href": scope.row.imported_file_url,
            "size": "small"
          }
        }, [_vm._v(_vm._s(scope.row.imported_file))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "log_file",
      "label": "Log File"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('a', {
          attrs: {
            "href": scope.row.log_file_url,
            "size": "small"
          }
        }, [_vm._v(_vm._s(scope.row.log_file))])]
      }
    }])
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "layout": "sizes, total, prev, pager, next",
      "page-size": 20,
      "total": _vm.total
    },
    on: {
      "current-change": _vm.handleCurrentChange,
      "size-change": _vm.handlePageSizeChange
    }
  })], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 243:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-row', {
    staticClass: "container"
  }, [_c('el-col', {
    staticClass: "header",
    attrs: {
      "span": 24
    }
  }, [_c('el-col', {
    staticClass: "logo",
    class: _vm.collapsed ? 'logo-collapse-width' : 'logo-width',
    attrs: {
      "span": 10
    }
  }, [_vm._v("\n\t\t\t" + _vm._s(_vm.collapsed ? '' : _vm.sysName) + "\n\t\t")]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 10,
      "lass": "logo"
    }
  }, [_c('span', {
    staticClass: "el-dropdown-link userinfo-inner",
    staticStyle: {
      "margin-left": "50%"
    }
  }, [_vm._v(" " + _vm._s(_vm.companyID))])]), _vm._v(" "), _c('el-col', {
    staticClass: "userinfo",
    attrs: {
      "span": 4
    }
  }, [_c('el-dropdown', {
    attrs: {
      "trigger": "hover"
    }
  }, [_c('span', {
    staticClass: "el-dropdown-link userinfo-inner"
  }, [_vm._v(_vm._s(_vm.sysUserName))]), _vm._v(" "), _c('el-dropdown-menu', {
    attrs: {
      "slot": "dropdown"
    },
    slot: "dropdown"
  }, [_c('el-dropdown-item', {
    nativeOn: {
      "click": function($event) {
        return _vm.logout($event)
      }
    }
  }, [_vm._v("Log Out")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    staticClass: "main",
    attrs: {
      "span": 24
    }
  }, [_c('aside', {
    class: _vm.collapsed ? 'menu-collapsed' : 'menu-expanded'
  }, [_c('el-menu', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.collapsed),
      expression: "!collapsed"
    }],
    staticClass: "el-menu-vertical-demo",
    attrs: {
      "default-active": _vm.$route.path,
      "unique-opened": "",
      "router": ""
    },
    on: {
      "open": _vm.handleopen,
      "close": _vm.handleclose,
      "select": _vm.handleselect
    }
  }, [_vm._l((_vm.$router.options.routes), function(item, index) {
    return (!item.hidden) ? [(!item.leaf) ? _c('el-submenu', {
      attrs: {
        "index": index + ''
      }
    }, [_c('template', {
      slot: "title"
    }, [_c('i', {
      class: item.iconCls
    }), _vm._v(_vm._s(item.name))]), _vm._v(" "), _vm._l((item.children), function(child) {
      return (!child.hidden) ? _c('el-menu-item', {
        key: child.path,
        attrs: {
          "index": child.path
        }
      }, [_vm._v(_vm._s(child.name) + "\n\t\t\t\t\t\t")]) : _vm._e()
    })], 2) : _vm._e(), _vm._v(" "), (item.leaf && item.children.length > 0) ? _c('el-menu-item', {
      attrs: {
        "index": item.children[0].path
      }
    }, [_c('i', {
      class: item.iconCls
    }), _vm._v(_vm._s(item.children[0].name) + "\n\t\t\t\t\t")]) : _vm._e()] : _vm._e()
  })], 2)], 1), _vm._v(" "), _c('section', {
    staticClass: "content-container"
  }, [_c('div', {
    staticClass: "grid-content bg-purple-light"
  }, [_c('el-col', {
    staticClass: "breadcrumb-container",
    staticStyle: {
      "margin-bottom": "10px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('strong', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.$route.name))])]), _vm._v(" "), _c('el-col', {
    staticClass: "content-wrapper",
    attrs: {
      "span": 24
    }
  }, [_c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [_c('router-view')], 1)], 1)], 1)])])], 1)
},staticRenderFns: []}

/***/ }),

/***/ 244:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-col', {
    attrs: {
      "span": 4,
      "lg": 6,
      "push": 1
    }
  }, [_c('el-dialog', {
    attrs: {
      "width": "1000",
      "title": "Invoice Sample Data",
      "visible": _vm.dialogTableVisible
    },
    on: {
      "close": function($event) {
        _vm.$emit('onClose')
      }
    }
  }, [_c('el-table', {
    attrs: {
      "data": _vm.gridData
    }
  }, [_c('el-table-column', {
    attrs: {
      "property": "reference",
      "label": "Reference",
      "width": "100"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "property": "invoiceDate",
      "label": "Invoice Date",
      "width": "110"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "property": "customerName",
      "label": "Customer Name",
      "width": "130"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "property": "amount",
      "label": "Amount",
      "width": "80"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "property": "currencyCode",
      "label": "Currency Code",
      "width": "125"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "property": "introduction",
      "label": "Introduction",
      "width": "110"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "property": "productNumber",
      "label": "Product Number",
      "width": "130"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "property": "quantity",
      "label": "Quantity",
      "width": "80"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "property": "price",
      "label": "Price",
      "width": "60"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "property": "accountCode",
      "label": "Account Code",
      "width": "120"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "property": "taxType",
      "label": "Tax type",
      "width": "80"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "property": "tax",
      "label": "Tax",
      "width": "80"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "property": "invoiceDueDate",
      "label": "Invoice Due Date",
      "width": "110"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "property": "invoiceNumber",
      "label": "Invoice Number",
      "width": "110"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('p', [_vm._v("Invoice date format should be "), _c('b', [_vm._v("MM/dd/yyyy")]), _vm._v(" format. You can download sample file "), _c('a', {
    attrs: {
      "href": "https://s3.amazonaws.com/workforcetrack/000000000000/invoice-import-app/public/Invoice_Import_Template.csv"
    }
  }, [_vm._v("here")])])])], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 245:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [_c('router-view')], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 246:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-col', {
    attrs: {
      "span": 4,
      "lg": 6,
      "push": 1
    }
  }, [_c('el-dialog', {
    attrs: {
      "width": "650",
      "title": "Invoice Payment Sample Data",
      "visible": _vm.dialogTableVisible
    },
    on: {
      "close": function($event) {
        _vm.$emit('onClose')
      }
    }
  }, [_c('el-table', {
    attrs: {
      "data": _vm.gridData
    }
  }, [_c('el-table-column', {
    attrs: {
      "property": "invoiceNumber",
      "label": "Invoice Number",
      "width": "130"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "property": "accountCode",
      "label": "Account Code",
      "width": "130"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "property": "amount",
      "label": "Amount",
      "width": "80"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "property": "reference",
      "label": "Reference",
      "width": "130"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "property": "paymentDate",
      "label": "Payment Date",
      "width": "130"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('p', [_vm._v("Invoice payment date format should be "), _c('b', [_vm._v("MM/dd/yyyy")]), _vm._v(" format. You can download sample file "), _c('a', {
    attrs: {
      "href": "https://s3.amazonaws.com/workforcetrack/000000000000/invoice-import-app/public/Invoice_Payment_Import_Template.csv"
    }
  }, [_vm._v("here")])])])], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 34:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var SIGN_REGEXP = /([yMdhsm])(\1*)/g;
var DEFAULT_PATTERN = 'yyyy-MM-dd';
function padding(s, len) {
    var len = len - (s + '').length;
    for (var i = 0; i < len; i++) {
        s = '0' + s;
    }
    return s;
};

exports.default = {
    getQueryStringByName: function getQueryStringByName(name) {
        var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
        var r = window.location.search.substr(1).match(reg);
        var context = "";
        if (r != null) context = r[2];
        reg = null;
        r = null;
        return context == null || context == "" || context == "undefined" ? "" : context;
    },
    formatDate: {

        format: function format(date, pattern) {
            pattern = pattern || DEFAULT_PATTERN;
            return pattern.replace(SIGN_REGEXP, function ($0) {
                switch ($0.charAt(0)) {
                    case 'y':
                        return padding(date.getFullYear(), $0.length);
                    case 'M':
                        return padding(date.getMonth() + 1, $0.length);
                    case 'd':
                        return padding(date.getDate(), $0.length);
                    case 'w':
                        return date.getDay() + 1;
                    case 'h':
                        return padding(date.getHours(), $0.length);
                    case 'm':
                        return padding(date.getMinutes(), $0.length);
                    case 's':
                        return padding(date.getSeconds(), $0.length);
                }
            });
        },
        parse: function parse(dateString, pattern) {
            var matchs1 = pattern.match(SIGN_REGEXP);
            var matchs2 = dateString.match(/(\d)+/g);
            if (matchs1.length == matchs2.length) {
                var _date = new Date(1970, 0, 1);
                for (var i = 0; i < matchs1.length; i++) {
                    var _int = parseInt(matchs2[i]);
                    var sign = matchs1[i];
                    switch (sign.charAt(0)) {
                        case 'y':
                            _date.setFullYear(_int);break;
                        case 'M':
                            _date.setMonth(_int - 1);break;
                        case 'd':
                            _date.setDate(_int);break;
                        case 'h':
                            _date.setHours(_int);break;
                        case 'm':
                            _date.setMinutes(_int);break;
                        case 's':
                            _date.setSeconds(_int);break;
                    }
                }
                return _date;
            }
            return null;
        }

    }

};

/***/ }),

/***/ 93:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _Login = __webpack_require__(233);

var _Login2 = _interopRequireDefault(_Login);

var _ = __webpack_require__(231);

var _2 = _interopRequireDefault(_);

var _Home = __webpack_require__(232);

var _Home2 = _interopRequireDefault(_Home);

var _InvoiceImport = __webpack_require__(234);

var _InvoiceImport2 = _interopRequireDefault(_InvoiceImport);

var _InvoicePaymentImport = __webpack_require__(235);

var _InvoicePaymentImport2 = _interopRequireDefault(_InvoicePaymentImport);

var _SalesOrderImport = __webpack_require__(236);

var _SalesOrderImport2 = _interopRequireDefault(_SalesOrderImport);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var routes = [{
    path: '/login',
    component: _Login2.default,
    name: '',
    hidden: true
}, {
    path: '/404',
    component: _2.default,
    name: '',
    hidden: true
}, {
    path: '/',
    component: _Home2.default,
    name: 'Menu',
    iconCls: 'el-icon-menu',
    children: [{ path: '/invoice-import', component: _InvoiceImport2.default, name: 'Sales Invoice' }, { path: '/invoice-payment-import', component: _InvoicePaymentImport2.default, name: 'Sales Invoice Payments' }, { path: '/sales-order-import', component: _SalesOrderImport2.default, name: 'Sales Order' }]
}, {
    path: '*',
    hidden: true,
    redirect: { path: '/404' }
}];

exports.default = routes;

/***/ }),

/***/ 94:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _vue = __webpack_require__(4);

var _vue2 = _interopRequireDefault(_vue);

var _vuex = __webpack_require__(58);

var _vuex2 = _interopRequireDefault(_vuex);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.use(_vuex2.default);

exports.default = new _vuex2.default.Store({
    state: {
        token: ''
    },
    getters: {
        token: function token(state) {
            return state.token;
        }
    },

    mutations: {
        setToken: function setToken(state, payload) {
            return state.token = payload;
        }
    }
});

/***/ }),

/***/ 97:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 99:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(219)

var Component = __webpack_require__(7)(
  /* script */
  __webpack_require__(142),
  /* template */
  __webpack_require__(245),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ })

},[151]);


// WEBPACK FOOTER //
// static/js/app.45fe17c96cd277eb1bd8.js